import React, {
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef,
} from "react";
import { RefreshCw } from "lucide-react";

const NumberCaptchaV2 = forwardRef(({ onRefresh }, ref) => {
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [answer, setAnswer] = useState("");

    useEffect(() => {
        generateCaptcha();
    }, []);

    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 10) + 1;
        const b = Math.floor(Math.random() * 10) + 1;
        setNum1(a);
        setNum2(b);
        setAnswer("");
        if (onRefresh) onRefresh();
    };

    useImperativeHandle(ref, () => ({
        validate() {
            const correct = num1 + num2;
            return parseInt(answer) === correct;
        },
        refresh() {
            generateCaptcha();
        },
    }));

    return (
        <div className="d-flex align-items-center">
            <label className="fw-bold me-2 mb-0 addersrquesttsxtpp">
                {num1} + {num2} = ?
            </label>
            <input
                type="number"
                className="form-control addesdwqtssxtoipnt"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                style={{ width: "80px" }}
                required
            />
            <button
                type="button"
                className="btn btn-outline-secondary btn-sm ms-2 ml-2"
                onClick={generateCaptcha}
                title="Refresh challenge"
            >
                <RefreshCw size={16} />
            </button>
        </div>
    );
});

export default NumberCaptchaV2;
